<div class="modal-header">
    <h5 class="modal-title">{{title}}</h5>
    <button type="button" class="btn-close" (click)="dismissModal()" aria-label="Close"></button>
</div>
<div class="modal-body">
    <div class="confirm-prompt" *ngIf="!promptHasHtml">{{prompt}}</div>
    <div class="confirm-prompt" *ngIf="promptHasHtml" [innerHTML]="prompt"></div>
    <div class="mt-3" *ngIf="reasonRequired || reasonLabel">
        <label class="form-label mb-1">{{ reasonLabel || 'Override Reason' }}</label>
        <textarea
            class="form-control"
            [rows]="reasonRows"
            [(ngModel)]="reasonText"
            [placeholder]="reasonPlaceholder"
        ></textarea>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-round" [ngClass]="cancelBtnClass" (click)="dismissModal()"><i class="far " *ngIf="cancelBtnIcon" [ngClass]="cancelBtnIcon"></i> {{cancelBtnText}}</button>
    <button
        type="submit"
        class="btn btn-round"
        focus-me
        [ngClass]="okBtnClass"
        (click)="confirmModal()"
        [disabled]="reasonRequired && !(reasonText && reasonText.trim().length)"
    ><i class="far " *ngIf="okBtnIcon" [ngClass]="okBtnIcon"></i> {{okBtnText}}</button>
</div>
